// import {
//   Button,
//   CardContent,
//   Grid,
//   TextField,
//   Typography,
//   Divider,
//   CircularProgress,
// } from "@mui/material";
// import ArrowBackSharpIcon from "@mui/icons-material/ArrowBackSharp";
// import { useEffect, useState, useRef } from "react";
// import axios from "axios";
// import { useNavigate } from "react-router-dom";
// import HOST_URL from "../../../utils/Url";
// import Autocomplete from "@mui/material/Autocomplete";
// import { useTranslation } from "react-i18next";
// import { useFormik } from "formik";
// import * as Yup from "yup";
// import { toast } from "react-toastify";
// import ToastApp from "../../../ToastApp";

// type Props = {};

// const SubDepartmentMasterAdd = (props: Props) => {
//   let navigate = useNavigate();
//   const { t } = useTranslation();
//   const [toaster, setToaster] = useState(false);
//   const [isSubmitting, setIsSubmitting] = useState(false);
//   const submitTimeoutRef = useRef<NodeJS.Timeout | null>(null);
//   const [deptOption, setDeptOption] = useState<{ label: string; value: number }[]>([]);

//   useEffect(() => {
//     getDepartmentName();
//   }, []);

//   const getDepartmentName = () => {
//     const collectData = {"id":-1,"nodeID":-1,"titleID":0};
//     axios
//       .post(HOST_URL.HOST_URL2 + `NewNodeMaster/GetNewNodeMaster`, collectData)
//       .then((res) => {
//         console.log("Department API Response:", res.data);
//         const arr: { label: string; value: number }[] = [];
//         if (res.data.data && res.data.data.length > 0) {
//           for (let index = 0; index < res.data.data.length; index++) {
//             arr.push({
//               label: res.data.data[index]["name"],
//               value: Number(res.data.data[index]["id"]),
//             });
//           }
//         }
//         setDeptOption(arr);
//       })
//       .catch((error) => {
//         console.error("Error fetching departments:", error);
//         toast.error(t("text.failedToFetch"));
//       });
//   };

//   const validationSchema = Yup.object({
//     deptID: Yup.number()
//       .required(t("text.reqdepartmentName"))
//       .test("not-zero", t("text.reqdepartmentName"), function (value: any) {
//         return value && value !== 0;
//       }),
//     subDeptName: Yup.string()
//       .required(t("text.reqsubDepartmentName"))
//       .max(30, t("text.subDepartmentNameMaxLength"))
//       .matches(/^[a-zA-Z\s\-]+$/, t("text.invalidSubDepartmentName"))
//   });

//   const formik = useFormik({
//     initialValues: {
//       subDeptID: 0,
//       deptID: 0,
//       subDeptName: "",
//       createdBy: 0,
//       createdDate: new Date().toISOString(),
//       departmentName: ""
//     },
//     validationSchema: validationSchema,
//     onSubmit: async (values) => {
//       if (submitTimeoutRef.current) {
//         clearTimeout(submitTimeoutRef.current);
//       }

//       if (isSubmitting) {
//         toast.info(t("text.requestInProgress"));
//         return;
//       }

//       setIsSubmitting(true);

//       try {
//         const selectedDept = deptOption.find(d => d.value === values.deptID);
//         const submitValues = {
//           ...values,
//           departmentName: selectedDept ? selectedDept.label : "",
//           isActive: true
//         };

//         const response = await axios.post(
//           HOST_URL.HOST_URL2 + `SubDepartmentMaster/AddUpdateSubDepartmentMaster`,
//           submitValues
//         );

//         if (response.data.isSuccess) {
//           setToaster(false);
//           toast.success(response.data.mesg);
//           navigate('/master/SubDepartmentMaster');
//         } else {
//           setToaster(true);
//           toast.error(response.data.mesg || t("text.failedToSave"));
//         }
//       } catch (error: any) {
//         console.error("Error saving:", error);
//         toast.error(error.response?.data?.mesg || t("text.somethingWentWrong"));
//         setToaster(true);
//       } finally {
//         submitTimeoutRef.current = setTimeout(() => {
//           setIsSubmitting(false);
//         }, 2000);
//       }
//     },
//   });

//   const requiredFields = ["subDeptName", "deptID"];

//   useEffect(() => {
//     return () => {
//       if (submitTimeoutRef.current) {
//         clearTimeout(submitTimeoutRef.current);
//       }
//     };
//   }, []);

//   const back = useNavigate();

//   return (
//     <div>
//       <div
//         style={{
//           padding: "-5px 5px",
//           backgroundColor: "#ffffff",
//           borderRadius: "5px",
//           marginTop: "5px",
//           border: ".5px solid #FF7722",
//         }}
//       >
//         <CardContent>
//           <Typography
//             variant="h5"
//             textAlign="center"
//             style={{ fontSize: "18px", fontWeight: 500 }}
//           >
//             {t("text.CreateSubDepartmentMaster")}
//           </Typography>

//           <Grid item sm={4} xs={12}>
//             <Typography style={{ marginTop: "-75px" }}>
//               <Button
//                 type="button"
//                 onClick={() => back(-1)}
//                 variant="contained"
//                 style={{
//                   marginBottom: 15,
//                   marginTop: "45px",
//                   backgroundColor: `var(--header-background)`,
//                   width: 20,
//                 }}
//                 disabled={isSubmitting}
//               >
//                 <ArrowBackSharpIcon />
//               </Button>
//             </Typography>
//           </Grid>
//           <Divider />
//           <br />
//           <form onSubmit={formik.handleSubmit}>
//             {toaster === false ? "" : <ToastApp />}
//             <Grid container spacing={2}>
//               <Grid xs={12} sm={6} item>
//                 <Autocomplete
//                   disablePortal
//                   id="department-autocomplete"
//                   options={deptOption}
//                   getOptionLabel={(option) => option.label}
//                   isOptionEqualToValue={(option, value) => option.value === value.value}
//                   fullWidth
//                   size="small"
//                   disabled={isSubmitting}
//                   value={deptOption.find(option => option.value === formik.values.deptID) || null}
//                   onChange={(event, newValue) => {
//                     formik.setFieldValue("deptID", newValue ? newValue.value : 0);
//                     formik.setFieldTouched("deptID", true);
//                   }}
//                   renderInput={(params) => (
//                     <TextField
//                       {...params}
//                       label={
//                         <span>
//                           {t("text.SelectDepartmentName")}
//                           {requiredFields.includes('deptID') && (
//                             <span style={{ color: formik.values.deptID ? 'green' : 'red' }}>*</span>
//                           )}
//                         </span>
//                       }
//                       error={formik.touched.deptID && Boolean(formik.errors.deptID)}
//                     />
//                   )}
//                 />
//                 {formik.touched.deptID && formik.errors.deptID && (
//                   <div style={{ color: "red", margin: "5px" }}>
//                     {String(formik.errors.deptID)}
//                   </div>
//                 )}
//               </Grid>

//               <Grid item xs={12} sm={6}>
//                 <TextField
//                   label={
//                     <span>
//                       {t("text.EnterSubDepartmentName")}
//                       {requiredFields.includes('subDeptName') && (
//                         <span style={{ color: formik.values.subDeptName ? 'green' : 'red' }}>*</span>
//                       )}
//                     </span>
//                   }
//                   value={formik.values.subDeptName}
//                   name="subDeptName"
//                   placeholder={t("text.EnterSubDepartmentName")}
//                   size="small"
//                   fullWidth
//                   onChange={(e) => {
//                     const value = e.target.value.replace(/[^a-zA-Z\s\-]/g, "");
//                     formik.setFieldValue("subDeptName", value);
//                   }}
//                   onBlur={formik.handleBlur}
//                   disabled={isSubmitting}
//                   inputProps={{ maxLength: 30 }}
//                   error={formik.touched.subDeptName && Boolean(formik.errors.subDeptName)}
//                 />
//                 {formik.touched.subDeptName && formik.errors.subDeptName && (
//                   <div style={{ color: "red", margin: "5px" }}>
//                     {String(formik.errors.subDeptName)}
//                   </div>
//                 )}
//               </Grid>

//               <Grid item xs={12} sm={6}>
//                 <Button
//                   type="submit"
//                   fullWidth
//                   style={{
//                     backgroundColor: `var(--header-background)`,
//                     color: "white",
//                     marginTop: "10px",
//                   }}
//                   disabled={isSubmitting || !formik.isValid}
//                   startIcon={isSubmitting ? <CircularProgress size={16} color="inherit" /> : null}
//                 >
//                   {isSubmitting ? t("text.submitting") : t("text.save")}
//                 </Button>
//               </Grid>
//               <Grid item xs={12} sm={6}>
//                 <Button
//                   type="reset"
//                   fullWidth
//                   style={{
//                     backgroundColor: "#F43F5E",
//                     color: "white",
//                     marginTop: "10px",
//                   }}
//                   disabled={isSubmitting}
//                   onClick={() => {
//                     formik.resetForm();
//                     formik.setFieldValue("deptID", 0);
//                   }}
//                 >
//                   {t("text.reset")}
//                 </Button>
//               </Grid>
//             </Grid>
//           </form>
//         </CardContent>
//       </div>
//     </div>
//   );
// };

// export default SubDepartmentMasterAdd;



import {
  Button,
  CardContent,
  Grid,
  TextField,
  Typography,
  Divider,
  CircularProgress,
} from "@mui/material";
import ArrowBackSharpIcon from "@mui/icons-material/ArrowBackSharp";
import { useEffect, useState, useRef } from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import HOST_URL from "../../../utils/Url";
import Autocomplete from "@mui/material/Autocomplete";
import { useTranslation } from "react-i18next";
import { useFormik } from "formik";
import * as Yup from "yup";
import { toast } from "react-toastify";
import ToastApp from "../../../ToastApp";

type Props = {};

const SubDepartmentMasterAdd = (props: Props) => {
  let navigate = useNavigate();
  const { t } = useTranslation();
  const [toaster, setToaster] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const submitTimeoutRef = useRef<NodeJS.Timeout | null>(null);
  const [deptOption, setDeptOption] = useState<{ label: string; value: number }[]>([]);

  useEffect(() => {
    getDepartmentName();
  }, []);

  const getDepartmentName = () => {
    const collectData = {"id":-1,"nodeID":-1,"titleID":0};
    axios
      .post(HOST_URL.HOST_URL2 + `NewNodeMaster/GetNewNodeMaster`, collectData)
      .then((res) => {
        console.log("Department API Response:", res.data);
        const arr: { label: string; value: number }[] = [];
        if (res.data.data && res.data.data.length > 0) {
          for (let index = 0; index < res.data.data.length; index++) {
            arr.push({
              label: res.data.data[index]["name"],
              value: Number(res.data.data[index]["id"]),
            });
          }
        }
        setDeptOption(arr);
      })
      .catch((error) => {
        console.error("Error fetching departments:", error);
        toast.error(t("text.failedToFetch"));
      });
  };

  const validationSchema = Yup.object({
    deptID: Yup.number()
      .required(t("text.reqdepartmentName"))
      .test("not-zero", t("text.reqdepartmentName"), function (value: any) {
        return value && value !== 0;
      }),
    subDeptName: Yup.string()
      .required(t("text.reqsubDepartmentName"))
      .max(30, t("text.subDepartmentNameMaxLength"))
      .matches(/^[a-zA-Z\s\-]+$/, t("text.invalidSubDepartmentName"))
  });

  const formik = useFormik({
    initialValues: {
      subDeptID: 0,
      deptID: 0,
      subDeptName: "",
      createdBy: 0,
      createdDate: new Date().toISOString(),
      departmentName: ""
    },
    validationSchema: validationSchema,
    onSubmit: async (values) => {
      if (submitTimeoutRef.current) {
        clearTimeout(submitTimeoutRef.current);
      }

      if (isSubmitting) {
        toast.info(t("text.requestInProgress"));
        return;
      }

      setIsSubmitting(true);

      try {
        const selectedDept = deptOption.find(d => d.value === values.deptID);
        const submitValues = {
          ...values,
          departmentName: selectedDept ? selectedDept.label : "",
          isActive: true
        };

        const response = await axios.post(
          HOST_URL.HOST_URL2 + `SubDepartmentMaster/AddUpdateSubDepartmentMaster`,
          submitValues
        );

        if (response.data.isSuccess) {
          setToaster(false);
          toast.success(response.data.mesg);
          navigate('/master/SubDepartmentMaster');
        } else {
          setToaster(true);
          toast.error(response.data.mesg || t("text.failedToSave"));
        }
      } catch (error: any) {
        console.error("Error saving:", error);
        toast.error(error.response?.data?.mesg || t("text.somethingWentWrong"));
        setToaster(true);
      } finally {
        submitTimeoutRef.current = setTimeout(() => {
          setIsSubmitting(false);
        }, 2000);
      }
    },
  });

  const requiredFields = ["subDeptName", "deptID"];

  useEffect(() => {
    return () => {
      if (submitTimeoutRef.current) {
        clearTimeout(submitTimeoutRef.current);
      }
    };
  }, []);

  const back = useNavigate();

  return (
    <div>
      <div
        style={{
          padding: "-5px 5px",
          backgroundColor: "#ffffff",
          borderRadius: "5px",
          marginTop: "5px",
          border: ".5px solid #FF7722",
        }}
      >
        <CardContent>
          <Typography
            variant="h5"
            textAlign="center"
            style={{ fontSize: "16px", fontWeight: 500, marginLeft: "30px" }}
          >
            {t("text.CreateSubDepartmentMaster")}
          </Typography>

          <Grid item sm={4} xs={12}>
            <Typography style={{ marginTop: "-75px" }}>
              <Button
                type="button"
                onClick={() => back(-1)}
                variant="contained"
                style={{
                  marginBottom: 15,
                  marginTop: "45px",
                  backgroundColor: `var(--header-background)`,
                  width: 20,
                }}
                disabled={isSubmitting}
              >
                <ArrowBackSharpIcon />
              </Button>
            </Typography>
          </Grid>
          <Divider />
          <br />
          <form onSubmit={formik.handleSubmit}>
            {toaster === false ? "" : <ToastApp />}
            <Grid container spacing={2}>
              <Grid xs={12} sm={6} item>
                <Autocomplete
                  disablePortal
                  id="department-autocomplete"
                  options={deptOption}
                  getOptionLabel={(option) => option.label}
                  isOptionEqualToValue={(option, value) => option.value === value.value}
                  fullWidth
                  size="small"
                  disabled={isSubmitting}
                  value={deptOption.find(option => option.value === formik.values.deptID) || null}
                  onChange={(event, newValue) => {
                    formik.setFieldValue("deptID", newValue ? newValue.value : 0);
                    formik.setFieldTouched("deptID", true);
                  }}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      label={
                        <span>
                          {t("text.SelectDepartmentName")}
                          {requiredFields.includes('deptID') && (
                            <span style={{ color: formik.values.deptID ? 'green' : 'red' }}>*</span>
                          )}
                        </span>
                      }
                      error={formik.touched.deptID && Boolean(formik.errors.deptID)}
                    />
                  )}
                />
                {formik.touched.deptID && formik.errors.deptID && (
                  <div style={{ color: "red", margin: "5px" }}>
                    {String(formik.errors.deptID)}
                  </div>
                )}
              </Grid>

              <Grid item xs={12} sm={6}>
                <TextField
                  label={
                    <span>
                      {t("text.EnterSubDepartmentName")}
                      {requiredFields.includes('subDeptName') && (
                        <span style={{ color: formik.values.subDeptName ? 'green' : 'red' }}>*</span>
                      )}
                    </span>
                  }
                  value={formik.values.subDeptName}
                  name="subDeptName"
                  placeholder={t("text.EnterSubDepartmentName")}
                  size="small"
                  fullWidth
                  onChange={(e) => {
                    const value = e.target.value.replace(/[^a-zA-Z\s\-]/g, "");
                    formik.setFieldValue("subDeptName", value);
                  }}
                  onBlur={formik.handleBlur}
                  disabled={isSubmitting}
                  inputProps={{ maxLength: 30 }}
                  error={formik.touched.subDeptName && Boolean(formik.errors.subDeptName)}
                />
                {formik.touched.subDeptName && formik.errors.subDeptName && (
                  <div style={{ color: "red", margin: "5px" }}>
                    {String(formik.errors.subDeptName)}
                  </div>
                )}
              </Grid>

              <Grid item xs={12} sm={6}>
                <Button
                  type="submit"
                  fullWidth
                  style={{
                    backgroundColor: `var(--header-background)`,
                    color: "white",
                    marginTop: "10px",
                  }}
                  disabled={isSubmitting || !formik.isValid}
                  startIcon={isSubmitting ? <CircularProgress size={16} color="inherit" /> : null}
                >
                  {isSubmitting ? t("text.submitting") : t("text.save")}
                </Button>
              </Grid>
              <Grid item xs={12} sm={6}>
                <Button
                  type="reset"
                  fullWidth
                  style={{
                    backgroundColor: "#F43F5E",
                    color: "white",
                    marginTop: "10px",
                  }}
                  disabled={isSubmitting}
                  onClick={() => {
                    formik.resetForm();
                    formik.setFieldValue("deptID", 0);
                  }}
                >
                  {t("text.reset")}
                </Button>
              </Grid>
            </Grid>
          </form>
        </CardContent>
      </div>
    </div>
  );
};

export default SubDepartmentMasterAdd;